import { ControlledForm, ControlledTable } from "Components";
import { FormDataType } from "DataTypes/Form";
import { columnType } from "DataTypes/Table";

export const Arr = [ControlledForm.FormData.AddNotes()];

export const Arr1: FormDataType[] = [
  ControlledForm.FormData.Callfreq(),
  ControlledForm.FormData.CompletionDate(),
];

export const Arr2: FormDataType[] = [
  {
    id: "interactive",
    label: "Was interactive communication done with the Patient?",
    placeholder: "Select an option",
    boxType: "empty-block",
    boxSize: 3,
    validatetype: "dropdown",
    dropArr: [
      { id: "Yes", label: "Yes", value: "Yes" },
      { id: "No", label: "No", value: "No" },
    ],
  },
  {
    id: "medically",
    label:
      "Are RPM Services medically reasonable & necessary for this patient?",
    placeholder: "Select an option",
    boxType: "empty-block",
    boxSize: 3,
    validatetype: "dropdown",
    dropArr: [
      { id: "Yes", label: "Yes", value: "Yes" },
      { id: "No", label: "No", value: "No" },
    ],
  },
];

export const TableCol: columnType[] = [
  ControlledTable.ColumnData.ProblemCol(),
  ControlledTable.ColumnData.GoalCol(),
  ControlledTable.ColumnData.InterventionCol(),
];
export const TCMTableCol: columnType[] = [
  ControlledTable.ColumnData.TcmProblemCol(),
  ControlledTable.ColumnData.TcmQuesCol(),
  //Separate column for tcm question in summary screen
];

export const RecurringCol: columnType[] = [
  ControlledTable.ColumnData.QuesAnsCol(),
];
